import MuiGlobalStyles from '@mui/material/GlobalStyles';
import { colorBlack, fontFamily } from './constants';

const disabledInputColor = `${colorBlack} !important`;

const disabled = {
  '&.Mui-disabled': {
    opacity: '0.85 !important',
    color: disabledInputColor,
    '-webkit-text-fill-color': disabledInputColor,
  },
};

export const GlobalStyles = () => {
  return (
    <MuiGlobalStyles
      styles={{
        body: { margin: 0, fontFamily, backgroundColor: 'black' },
        input: {
          ...disabled,
        },
        label: {
          ...disabled,
        },
        // Scrollbar styles
        '*': {
          // Firefox
          scrollbarWidth: 'thin',
          scrollbarColor: '#b9a86e #1B1B1B',
        },
        // Webkit browsers (Chrome, Safari, Edge)
        '*::-webkit-scrollbar': {
          width: '12px',
          height: '12px',
        },
        '*::-webkit-scrollbar-track': {
          backgroundColor: '#1B1B1B',
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: '#b9a86e',
          borderRadius: '6px',
          border: '2px solid #1B1B1B',
        },
        '*::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#c5b57d',
        },
      }}
    />
  );
};
